import { useBaseModalStore } from '@/stores/modal';

export default {
  methods: {
    // The following methods can be used inside event handlers for the PageTemplateRenderer

    toggleModal(modal) {
      const modalStore = useBaseModalStore();
      modalStore.setProps(modal);
      modalStore.setComponent(modal.component);
      modalStore.setTitle(modal.title);
    },
  },
};
